import React, {Component} from "react";
import Input from "../../reusable/components/Input";
import Button from "../../reusable/components/Button.jsx";
import Select from '../../reusable/components/Select';
import TextArea from '../../reusable/components/TextArea';
import {Modal} from '@deere/ux.uxframe-react';
import {getDefaultState} from '../state';
import baseurl from '../../api-properties';
import {isMobile} from 'react-device-detect';
import {Alert} from '@deere/ux.uxframe-react';

if (isMobile) {
    import('../../mobileindex.css').then(() => {
    });
} else {
    import('../../index.css').then(() => {
    });
}

class SupplierGeneralInfo extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            countryOptions: [],
            stateOptions: [],
            hearAboutUsOptions: [],
            inputFields: getDefaultState(),
            otherSelected: false,
            otherValue: "",
            submitted: false,
            formValue: {
                companyName: "", country: "", parentCoName: "", websiteUrl: "", phone: "",
                city: "", companyState: "", zip: "", contactName: "", emailAddress: "",
                jobTitle: "", confirmEmailAddress: "", address: "", stateOpt: "", businessCode: "", hearAboutUs: ""
            },
            formErrors: {
                compName: "", compCountry: "", compParent: "", compAddress: "", compWebsite: "", compPhone: "",
                compCity: "", compState: "", compZip: "", compBusinesCd: "",
                compContact: "", compJobTitle: "",
                compEmail: "", compConfirmEmail: "", showError: false
            }
        };
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleOtherInput = this.handleOtherInput.bind(this);
        this.handleOtherDropdown = this.handleOtherDropdown.bind(this);
    }

    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;

        this.setState(
            prevState => ({
                formValue: {
                    ...prevState.formValue,
                    [name]: value
                }
            }),
            () => {
                this.loadDropDownList(name)
            }
        );
    }

    handleOtherDropdown(e) {
        let value = e.target.value;
        let name = e.target.name;

        this.setState({
            otherSelected: value === "Other"
        });

        this.setState(
            prevState => ({
                formValue: {
                    ...prevState.formValue,
                    [name]: value
                }
            }));
    }

    handleOtherInput(e) {
        let value = e.target.value;
        this.setState(prevState => ({
            formValue: {
                ...prevState.formValue,
                hearAboutUs: value
            }
        }));
    }

    loadDropDownList = (name) => {
        if (name === "country") {
            this.loadStateList();
        }

    }

    handleButtonSubmit = (e) => {
        e.preventDefault();
        this.formError = this.validateOnSubmit();
        if (this.formError) {
            this.validateEmail(e).then(resp => this.setState({validated: resp}));
        }
    }

    async validateEmail(e) {
        e.preventDefault();
        let userData = {proSuppEmail: this.state.formValue.emailAddress};
        try {
            await this.callAPI(userData)
            return true
        } catch {
            return false
        }
    }

    callAPI = (userData) => {
        return new Promise((resolve, reject) => {
            fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/validateEmail", {
                method: "POST",
                body: JSON.stringify(userData),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            }).then(response => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                } else if (response.status === 204) {
                    this.props.showSubmitModal();
                } else if (response.status === 200) {
                    let fieldErrors = this.state.formErrors;
                    fieldErrors.showError = true;
                    fieldErrors.compEmail = "Email Address is already registered to another application.";
                    this.setState({formErrors: fieldErrors});
                }
                resolve(response);
            })
                .catch(error => {
                    reject(error)
                });
        })
    }

    componentDidMount() {
        this.loadCountryList();
        this.loadStateList();
        this.getParamComment();
    }

    loadCountryList = () => {
        fetch(baseurl.COUNTRY_API_URL + "countries/")
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                let countryList = data.map(result => {
                    return {value: result.iso2_cntry_cd, display: result.shrt_cntry_nm}
                })
                this.setState({countryOptions: [{value: '', display: 'Select...'}].concat(countryList)});
            }).catch(error => {
            console.log(error);
        });
    }

    getParamComment = () => {
        fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParamsByCategory/categoryCd/localecd?categoryId=HEAR_ABOUT_US&localeCd=en_US", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        })
            .then(data => {
                console.log("data is" + data)
                let hearAboutUsList = data.map(result => {
                    return {value: result.paramValue, display: result.paramValue}
                })
                console.log(hearAboutUsList)
                this.setState({hearAboutUsOptions: [{value: '', display: 'Select...'}].concat(hearAboutUsList)});
            }).catch(error => {
            console.log(error);
        });
    }

    loadStateList = () => {
        let countryCd = this.state.formValue.country;
        if (countryCd === undefined || countryCd == null || countryCd === "") {
            this.setState({stateOptions: [{value: '', display: 'Select...'}]});
        } else {
            fetch(baseurl.STATE_API_URL + "stateapi/getStates/" + countryCd)
                .then((response) => {
                    if (response.status === 204) {
                        this.setState({stateOptions: [{value: '', display: 'Select...'}]});
                    } else {
                        if (response.status === 401 || response.status === 403) {
                            window.location.href = "/error";
                        }
                        return response.json();
                    }
                })
                .then(data => {
                    let stateList = data.map(result => {
                        return {value: result.stateId, display: result.stateName}
                    })
                    this.setState({stateOptions: [{value: '', display: 'Select...'}].concat(stateList)});
                }).catch(error => {
                console.log(error);
            });
        }
    }

    handleClose = (e) => {
        e.preventDefault();
        this.props.closeSubmitModal();
    }

    handleFormSubmit(e) {
        e.preventDefault();
        let userData = this.state.formValue;
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/saveSupplier", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response
        }).then(() => {
            this.setState({submitted: true});
            this.handleClose(e);
            window.location.href = "/login";
        }).catch(error => {
            console.log(error);
        });
    }

    validateOnSubmit = () => {
        let fieldErrors = this.state.formErrors;
        let error = this.validationMessage();
        if (error) {
            fieldErrors.showError = true;
            this.setState({formErrors: fieldErrors});
        } else {
            fieldErrors.showError = false;
            this.setState({formErrors: fieldErrors});
        }
        return !error;
    };

    validationMessage = () => {
        const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        let fieldErrors = this.state.formErrors;
        let isValid = "";

        if (this.state.formValue.companyName.length <= 0) {
            fieldErrors.compName = "Company name is required field.";
            isValid = true;
        } else fieldErrors.compName = "";

        if (this.state.formValue.country.length <= 0) {
            fieldErrors.compCountry = "Country is required field.";
            isValid = true;
        } else fieldErrors.compCountry = "";

        /*if (this.state.formValue.parentCoName.length <= 0) {
          fieldErrors.compParent = "Parent Company Name is required field.";
          isValid = true;
        } else fieldErrors.compParent = "";*/

        if (this.state.formValue.address.length <= 0) {
            fieldErrors.compAddress = "Address is required field.";
            isValid = true;
        } else fieldErrors.compAddress = "";

        if (this.state.formValue.websiteUrl.length <= 0) {
            fieldErrors.compWebsite = "Website url is required field.";
            isValid = true;
        } else fieldErrors.compWebsite = "";

        if (this.state.formValue.phone.length <= 0) {
            fieldErrors.compPhone = "Telephone is required field.";
            isValid = true;
        } else fieldErrors.compPhone = "";


        if (this.state.formValue.city.length <= 0) {
            fieldErrors.compCity = "City is required field.";
            isValid = true;
        } else fieldErrors.compCity = "";

        /*if (this.state.formValue.companyState.length <= 0) {
          fieldErrors.compState = "State is required field.";
          isValid = true;
        } else fieldErrors.compState = "";*/

        if (this.state.formValue.zip.length <= 0) {
            fieldErrors.compZip = "Zip Code is required field.";
            isValid = true;
        } else fieldErrors.compZip = "";

        if (this.state.formValue.businessCode.length <= 0) {
            fieldErrors.compBusinesCd = "Business Code is required field.";
            isValid = true;
        } else fieldErrors.compBusinesCd = "";

        if (this.state.formValue.contactName.length <= 0) {
            fieldErrors.compContact = "Contact name is required field.";
            isValid = true;
        } else fieldErrors.compContact = "";

        if (this.state.formValue.emailAddress.length <= 0) {
            fieldErrors.compEmail = "Email address is required field.";
            isValid = true;
        } else if (this.state.formValue.emailAddress.length > 0 && reg.test(this.state.formValue.emailAddress) === false) {
            fieldErrors.compEmail = "Email Address is not valid.";
            isValid = true;
        } else fieldErrors.compEmail = "";

        if (this.state.formValue.jobTitle.length <= 0) {
            fieldErrors.compJobTitle = "Job title is required field.";
            isValid = true;
        } else fieldErrors.compJobTitle = "";

        if (this.state.formValue.confirmEmailAddress.length <= 0) {
            fieldErrors.compConfirmEmail = "Confirm  Email address is required field.";
            isValid = true;
        } else if (this.state.formValue.confirmEmailAddress.length > 0 && this.state.formValue.confirmEmailAddress !== this.state.formValue.emailAddress) {
            fieldErrors.compConfirmEmail = "Email and confrim email should match.";
            isValid = true;
        } else {
            fieldErrors.compConfirmEmail = "";
        }
        return isValid;
    };

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    render() {
        return (
            <div>
                {this.state.validated === false &&
                    <div>
                        <Alert variant="danger" aria-atomic="true">
                            <h5 className="uxf-alert-title">Internal Server Error</h5>
                            <p className="uxf-alert-description">Please contact <a
                                href="https://jdsn.deere.com/wps/portal/jdsn/Home/contact/" target="_blank">Help Desk</a>
                            </p>
                        </Alert>
                    </div>}
                {this.state.submitted === true &&
                    <div>
                        <Alert variant="success" aria-atomic="true">
                            <h5 className="uxf-alert-title">Success!</h5>
                            <p className="uxf-alert-description">An email has been sent to the email address provided below. Please check the email for login instructions.
                            </p>
                        </Alert>
                    </div>
                }
                <div className="row">
                    <div className="col-sm-8">
                        <Input title={"Company Name"}
                               tabIndex="1"
                               type={"text"}
                               name={"companyName"}
                               value={this.props.companyName}
                               handleChange={this.handleInput}
                               maxLength="40"
                        />
                        <span className="error">{this.state.formErrors.compName}</span>
                    </div>
                    <div className="col-sm-8">
                        <div className="form-group">
                            <Select
                                title={"Country"}
                                name={"country"}
                                tabIndex="5"
                                options={this.state.countryOptions}
                                value={this.props.country}
                                handleChange={this.handleInput}
                                defaultValue=""

                            />{"  "}<span className="error">{this.state.formErrors.compCountry}</span>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <Input
                            type={"text"}
                            tabIndex="2"
                            name={"parentCoName"}
                            title={"Parent Company Name"}
                            value={this.props.parentCoName}
                            handleChange={this.handleInput}
                            maxLength="40"
                        />
                        <span className="error">{this.state.formErrors.compParent}</span>
                        <Input
                            type={"text"}
                            name={"websiteUrl"}
                            tabIndex="3"
                            title={"Website URL"}
                            value={this.props.websiteUrl}
                            handleChange={this.handleInput}
                            maxLength="80"
                        />
                        <span className="error">{this.state.formErrors.compWebsite}</span>
                    </div>
                    <div className="col-sm-16">
                        <TextArea
                            name={"address"}
                            title={"Address"}
                            rows={"4"}
                            tabIndex="6"
                            value={this.props.address}
                            handleChange={this.handleInput}
                            maxLength="200"
                        /><span className="error">{this.state.formErrors.compAddress}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <Input
                            type={"text"}
                            name={"phone"}
                            tabIndex="4"
                            title={"Telephone"}
                            value={this.props.phone}
                            handleChange={this.handleInput}
                            maxLength="18"
                            onInput={this.maxLengthCheck}
                        />{""}<span className="error">{this.state.formErrors.compPhone}</span>
                    </div>
                    <div className="col-sm-6">
                        <Input
                            type={"text"}
                            tabIndex="7"
                            name={"city"}
                            title={"City"}
                            value={this.props.city}
                            handleChange={this.handleInput}
                            maxLength="28"
                        />{""}<span className="error">{this.state.formErrors.compCity}</span>
                    </div>
                    <div className="col-sm-5">
                        <Select
                            title={"State"}
                            name={"stateOpt"}
                            tabIndex="8"
                            options={this.state.stateOptions}
                            value={this.props.stateOpt}
                            handleChange={this.handleInput}
                            defaultValue=""
                        />{" "}<span className="error">{this.state.formErrors.compState}</span>
                    </div>
                    <div className="col-sm-5">
                        <Input
                            type={"text"}
                            name={"zip"}
                            tabIndex="9"
                            title={"Postal Code"}
                            value={this.props.zip}
                            handleChange={this.handleInput}
                            maxLength="10"
                        />{" "}<span className="error">{this.state.formErrors.compZip}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <div><label className="uxf-label">Have you ever done business with John Deere?</label></div>
                        <div className="btn-group btn-group-toggle" data-toggle="buttons" role="group">
                            <label
                                className={this.state.formValue.businessCode === "Y" ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                <input type="radio" name="businessCode" id="businessCodeY" autoComplete="off" value="Y"
                                       onChange={(event) => this.handleInput(event)}/>Yes
                            </label>
                            <label
                                className={this.state.formValue.businessCode === "N" ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                <input type="radio" name="businessCode" id="businessCodeN" autoComplete="off" value="N"
                                       onChange={(event) => this.handleInput(event)}/>No
                            </label>
                        </div>
                        <div className="error">{this.state.formErrors.compBusinesCd}</div>
                    </div>
                    <div className="col-sm-6">
                        <div><Select
                            title={"How did you hear about us?"}
                            name={"hearAboutUs"}
                            tabIndex="8"
                            options={this.state.hearAboutUsOptions}
                            value={this.props.hearAboutUs}
                            defaultValue=""
                            handleChange={this.handleOtherDropdown}
                        />

                        </div>
                    </div>

                    <div className="col-sm-8">
                        {this.state.otherSelected ? (
                            <Input
                                title={"Other source..."}
                                type={"text"}
                                tabIndex="10"
                                name={"otherInput"}
                                handleChange={this.handleOtherInput}
                                maxLength="40"
                            />
                        ) : null
                        }
                    </div>

                </div>
                <div className="row">
                    <div className="col-sm-24">
                        <h4 className="component-section-title">Key Contact</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <Input
                            type={"text"}
                            title={"Contact Name"}
                            tabIndex="10"
                            name={"contactName"}
                            value={this.props.contactName}
                            handleChange={this.handleInput}
                            maxLength="40"
                        />{" "}<span className="error">{this.state.formErrors.compContact}</span>
                    </div>
                    <div className="col-sm-16">
                        <Input
                            type={"text"}
                            name={"emailAddress"}
                            tabIndex="13"
                            title={"Email Address"}
                            value={this.props.emailAddress}
                            handleChange={this.handleInput}
                            maxLength="67"
                        /><span className="error">{this.state.formErrors.compEmail}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <Input
                            type={"text"}
                            title={"Job Title"}
                            tabIndex="12"
                            name={"jobTitle"}
                            value={this.props.jobTitle}
                            handleChange={this.handleInput}
                            maxLength="60"
                        />{" "}<span className="error">{this.state.formErrors.compJobTitle}</span>
                    </div>
                    <div className="col-sm-16">
                        <Input
                            type={"text"}
                            tabIndex="14"
                            name={"confirmEmailAddress"}
                            title={"Confirm Email Address"}
                            value={this.props.confirmEmailAddress}
                            handleChange={this.handleInput}
                            maxLength="67"
                        />{""}<span className="error">{this.state.formErrors.compConfirmEmail}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-24" style={{textAlign: 'right'}}>
                        <Button
                            disabled={this.state.submitted}
                            action={this.handleButtonSubmit}
                            type={"warning"}
                            title={"Submit"}
                        />{" "}
                    </div>
                    <br/><br/>
                </div>
                <Modal show={this.props.modValue && !this.state.submitted}>
                    <Modal.Header>
                        <h5 className="modal-title">Submit Application</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="uxf-alert-title">
                            We need a little more information about your company.<br/>
                            Please check your email to complete the application process.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="secondary btn-md"
                                action={this.handleClose}
                                title={"Cancel"}>
                        </Button>&nbsp;&nbsp;
                        <Button type="warning"
                                action={this.handleFormSubmit}
                                title={"Continue"}>
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}

//const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
export default SupplierGeneralInfo;